import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { isPristine } from 'redux-form';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestMeetingTypes } from '../../../store/meeting-types/MeetingTypesActions';
import { requestEscalationTypes } from '../../../store/escalation-types/EscalationTypesActions';
import EventForm from '../components/EventForm';
import {
  requestEvent,
  updateEvent,
  deleteEvent,
} from '../../../store/event-manager/EventManagerActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { hostTitle } from '../../../config/ui';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class EventEdit extends React.Component {
  componentWillMount() {
    this.props.getEvent(this.props.params.meetingId, {
      tenantId: this.props.tenantId,
    });
    this.props.getMeetingTypes({
      tenantId: this.props.tenantId,
    });
    this.props.getEscalationTypes({
      tenantId: this.props.tenantId,
    });
  }

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 500,
        order: '',
        search,
        filters,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}`,
            }),
          );
        }
        return options;
      });
  };

  onFormSubmit = (values) => {
    this.props
      .updateEvent(values, {
        tenantId: this.props.tenantId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Event has been saved.');
          hashHistory.push('/event-manager/');
        }
      });
  };

  onFormCancel = () => {
    if (!this.props.isEventFormDirty) {
      if (
        window.confirm(
          'Your information will not be saved. Would you like to proceed?',
        )
      ) {
        hashHistory.push('/event-manager/');
      }
    } else {
      hashHistory.push('/event-manager/');
    }
  };

  render() {
    const {
      data: { event },
      meetingtypes,
      escalationtypes,
      isExecutive
    } = this.props;

    const meetingTypesOptions =
      meetingtypes.data &&
      meetingtypes.data.map((item) => ({
        value: item.id,
        label: item.type,
      }));

    const escalationTypesOptions =
      escalationtypes.data &&
      escalationtypes.data.map((item) => ({
        value: item.id,
        label: item.type,
      }));

    return (
      <div id="content">
        {event.meetingId && <Helmet title={`${event.meetingId} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Event Manager', route: '/event-manager' },
            'Event',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />
        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>Edit Event </h2>
            </header>
            <div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                  <div className="row">
                    <div className="col-md-9">
                      <span> Event Id: {event.meetingId} </span>
                      <br />
                      <span>
                        {' '}
                        Client: {this.props.params.employerCodeNumber} |{' '}
                        {this.props.params.clientName}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onFormCancel}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  {
                    <EventForm
                      onSubmit={this.onFormSubmit}
                      onCancel={this.onFormCancel}
                      meetingtypes={meetingTypesOptions}
                      escalationtypes={escalationTypesOptions}
                      searchUsers={this.searchUsers}
                      isExecutive={isExecutive}
                    />
                  }
                </div>
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.eventmanager,
    users: state.users,
    meetingtypes: state.meetingtypes,
    escalationtypes: state.escalationtypes,
    isEventFormDirty: isPristine('event')(state),
    tenantId: state.currentUser.queryParams.tenantId,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getMeetingTypes: (params) => dispatch(requestMeetingTypes(params)),
    getEscalationTypes: (params) => dispatch(requestEscalationTypes(params)),
    getEvent: (meetingId, params) => dispatch(requestEvent(meetingId, params)),
    updateEvent: (event, params) => dispatch(updateEvent(event, params)),
    deleteEvent: (meetingId, params) =>
      dispatch(deleteEvent(meetingId, params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
  }),
)(EventEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/EventEdit.js